<template>
    <!-- TODO css -->
    <modal @close="modals.paymentMethodModal = false">
        <h3>New Payment Card</h3>
        
        <div v-if="screen === 'loading'">
            <div class="ws-form-processing"><div class="value-loader"></div></div>
        </div>
        
        <div v-if="screen === 'processing'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>Saving your payment method...</p></div>
        </div>
        
        <div v-if="screen === 'error'">
            <div class="ws-form-processing"><p>There was an error connecting to the payment gate. Please try again later. If the problem persists, please contact us.</p></div>
        </div>
        
        <div v-if="screen === 'final'">
            <div class="ws-form-processing">{{ finalMessage }}</div>
        </div>
        
        <div v-show="screen === 'form'" class="large-form">
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <div id="payment-element" >
                        <!-- Stripe Payment Element -->
                    </div>
                </div>
            </div>
            <div class="modal-errors">
                <p v-for="e in errors" class="error-text">{{ e }}</p>
            </div>
        </div>
        
        <div class="form-actions">
            <span v-if="screen === 'final'" class="ws-button" @click="modals.paymentMethodModal = false">CLOSE</span>
            <span v-else class="ws-button ws-button-secondary" @click="modals.paymentMethodModal = false">CANCEL</span>
            
            <span v-if="screen === 'form'" class="ws-button ws-button-main" @click="addPaymentMethod">ADD PAYMENT CARD</span>
        </div>
                
    </modal>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js';
import Modal from "@/components/modals/Modal";

export default {
    name: "PaymentMethodModal",
    components: {Modal},
    props: {
        source: String,
    },
    data() {
        return {
            screen: 'loading',
            paymentIntent: [],
            stripe: null,    
            options: {
                clientSecret: null,
                appearance: {
                    theme: 'stripe',
                    variables: {
                        fontSizeBase: "15px",
                    }
                },
            },     
            elements: null,
            paymentElement: null,
            confirmSetup: null,
            errors: {},
            finalMessage: "",
        }
    },
    methods: {
        async addPaymentMethod() {
            if (!this.demoCheck()) return;
            
            this.screen = 'processing';    
            let elements = this.elements;
            this.confirmSetup = await this.stripe.confirmSetup({
                elements,
                confirmParams: {
                  return_url: window.location.origin + window.location.pathname + '?stripe_method=not_allowed',
                },
                redirect: "if_required",
            });

            if (this.confirmSetup.error) {
                this.screen = 'form';                
                this.errors.stripe = this.confirmSetup.error.message;
                
            } else if (this.confirmSetup.setupIntent) {
                switch (this.confirmSetup.setupIntent.status) {
                    case 'succeeded': {
                      if (this.source == 'checkout') await this.dispatchWaitAndNotify('fetchStripePaymentMethods', null, false, true);
                      this.$emit('added',this.confirmSetup.setupIntent.payment_method);
                      this.finalMessage = 'Success! Your payment method has been saved.';
                      this.screen = 'final';
                      this.dispatchWaitAndNotify('preferStripePaymentMethod', this.confirmSetup.setupIntent.payment_method, false, true);
                      break;
                    }
                    case 'processing': {
                      this.finalMessage = "Processing payment details. We'll update you when processing is complete.";
                      this.screen = 'final';
                      await this.dispatchWaitAndNotify('fetchStripePaymentMethods', null, false, true);
                      break;
                    }

                    case 'requires_payment_method': {
                      this.errors.stripe = 'Failed to process payment details. Please try another payment method.';
                      this.screen = 'form';
                      break;
                    }
                }
            }
        },
    },
    async mounted() {
        this.paymentIntent = await this.dispatchWaitAndNotify('createStripePaymentIntent', null, false, true);
        this.stripe = await loadStripe(this.paymentIntent.publicKey);
        
        if (this.stripe) {
            this.options.clientSecret = this.paymentIntent.clientSecret;
            this.elements = this.stripe.elements(this.options);
            this.paymentElement = this.elements.create('payment');
            this.paymentElement.mount('#payment-element');
            
            this.screen = 'form';            
        } else {
            this.screen = 'error';
        }        
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>